import React, { useEffect, useState } from "react";
import accountsFlowApi from "../../services/accountsFlowService";

/*
 * Books per company: the company filter on the accounting reports and lists. Blank = all
 * companies. The choice is kept while moving between report pages.
 */
const KEY = "accountsCompanyFilter";
let cached = null;

function readSaved() {
  try {
    return localStorage.getItem(KEY) || "";
  } catch (err) {
    return "";
  }
}

export function useCompanyFilter() {
  const [company, setCompany] = useState(readSaved);
  const change = (value) => {
    setCompany(value);
    try {
      localStorage.setItem(KEY, value);
    } catch (err) {
      // storage unavailable: the filter just isn't remembered
    }
  };
  return [company, change];
}

export function CompanySelect({ value, onChange }) {
  const [companies, setCompanies] = useState(cached || []);
  useEffect(() => {
    if (cached) return;
    accountsFlowApi.companies()
      .then((result) => {
        cached = result?.data || [];
        setCompanies(cached);
      })
      .catch(() => setCompanies([]));
  }, []);
  return (
    <label className="tally-field">Company
      <select className="form-select" value={value} onChange={(event) => onChange(event.target.value)}>
        <option value="">All companies</option>
        {companies.map((row) => (
          <option key={row.code} value={row.code}>{row.code}{row.name ? ` – ${row.name}` : ""}</option>
        ))}
      </select>
    </label>
  );
}

/* Adds companyCode to a query when one is chosen. */
export function withCompany(query, company) {
  return company ? { ...query, companyCode: company } : query;
}
